import {APIClient} from "./client";

const config = {
    baseURL: process.env.SUBJECTS_API_URL
};

export default {

    client: new APIClient(config),

    search(query, limit = 10, expandCategories = false) {
        return this.client.get('/search', {
            params: {
                q: query,
                max_results: limit,
                expand_categories: expandCategories,
            },
        });
    },

    extendedSearch(query, limit = 10) {
        return this.search(query, limit, true);
    },

    get(subjectId) {
        return this.client.get('/subjects/' + subjectId);
    },

    getCategories() {
        return this.client.get('/categories');
    }
}
